const respectLabels = {
    fr: {
        R_1: "Intelligence Relationnelle",
        E_2: "Intelligence Emotionnelle",
        S_3: "Intelligence Situationnelle",
        P_4: "Pédagogie partage",
        E_5: "Enthousiasme engagement",
        C_6: "Client - orienté(e) (Centrix)",
        T_7: "Traitement de l’info"
    },
    en: {
        R_1: "Intelligence Relationnelle",
        E_2: "Intelligence Emotionnelle",
        S_3: "Intelligence Situationnelle",
        P_4: "Pédagogie partage",
        E_5: "Enthousiasme engagement",
        C_6: "Client - orienté(e) (Centrix)",
        T_7: "Traitement de l’info"
    }
}
export default respectLabels
